export const colors = {
    primary: '#3a729c',      // Green color for buttons/logo
    primaryHover: '#009440',
    white: '#FFFFFF',
    black: '#000000',
    textPrimary: '#1A1A1A',
    textSecondary: '#666666',
    background: '#F8F9FA',
    border: '#3a729c',
  };